<template>
   <div>
   </div>
</template>
<script>
   import c from "Vue/Core/constants.js"
   export default {
     name: "loginredirect",
     data() {
         return {
               test:'',
         }
     },
      created() {
            this.$loading({ 'loadingText': 'Loading...' })
            window.location.href =  c.WSO2BASEURL;
            this.$loading({}).close();
         },
        
         methods:{

         }
         
   };
</script>
<style>
  
</style>


// WEBPACK FOOTER //
// src/components/LoginRedirection.vue